// frontend/src/hooks/useInAppSyncStatus.js
//
// The selected store's sync-status payload for a reader inside the app: the
// sidebar's `SyncProgressPill`, the Home tiles, the Forecast link. The same
// query as the entry order (`hooks/useSyncStatus.syncStatusQueryOptions`), so
// TanStack dedupes the read into one poll loop. Null until the read lands,
// and for a store that is not a Shopify store (nothing is read for it).

import { useQuery } from '@tanstack/react-query';

import { useAuth, useIsShopify } from '../contexts/AuthContext';
import { syncStatusQueryOptions } from './useSyncStatus';

/**
 * The query itself, for the one reader that says when a read failed: the
 * pill. Every other reader takes the payload (`useInAppSyncStatus`).
 */
export function useInAppSyncQuery() {
  const { selectedStore } = useAuth();
  const isShopify = useIsShopify();
  const storeId = selectedStore?.id ?? null;
  return useQuery({
    ...syncStatusQueryOptions(storeId, { accessDenied: false }),
    enabled: isShopify && !!storeId,
  });
}

export function useInAppSyncStatus() {
  return useInAppSyncQuery().data ?? null;
}

export default useInAppSyncStatus;
